import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { DressingRuleEditForm } from "application/dressing-rule/forms";
import { LookupService } from "common/services";
import { DressingRuleService } from "application/dressing-rule/services";
import { action, observable } from "mobx";

class DressingRuleEditViewStore extends BaseEditViewStore {
    form = new DressingRuleEditForm({
        onSuccess: async (form) => {
            await this.onSubmit(form.values());
        },
    });
    params = {
        id: this.rootStore.routerStore.routerState.params.id,
    };

    @observable accessor isBordered = false;
    @observable accessor isDressingChange = false;
    @observable accessor isExistingDressingRule = false;

    constructor(rootStore) {
        const service = new DressingRuleService(
            rootStore.application.baasic.apiClient
        );
        const lookupService = new LookupService(
            rootStore.application.baasic.apiClient
        );

        const id = rootStore.routerStore.routerState.params.id;

        super(rootStore, {
            name: "dressing-rule",
            Form: DressingRuleEditForm,
            authorization: "administrationSection.update",
            actions: () => {
                return {
                    create: async (resource) => {
                        if (id != null) {
                            const response = await service.update(resource);
                            return response.data;
                        }
                        const response = await service.create(resource);
                        if(!response.data)
                        {
                            rootStore.notificationStore.error("A dressing rule with that code already exists");
                        }
                        else if(response.data)
                        {
                            rootStore.notificationStore.success("Successfully created dressing rule.");
                            return response.data;
                        }
                        else
                        {
                            rootStore.notificationStore.error("Unknown error occurred");
                        } 
                    },
                };
            },
            FormClass: DressingRuleEditForm,
        });

        this.procedureCodeStore = new BaasicDropdownStore(
            {
                filterable: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "procedurecode"
                    );
                    return response["procedureCodes"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        this.frequencyOfCareStore = new BaasicDropdownStore(
            {
                filterable: false,
                multi: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "frequencyofcare"
                    );
                    return response["frequencyOfCare"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        this.exudateTypeStore = new BaasicDropdownStore(
            {
                filterable: false,
                multi: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "exudatetype"
                    );
                    return response["exudateType"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        this.thicknessTypeStore = new BaasicDropdownStore(
            {
                filterable: false,
                multi: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "thicknesstype"
                    );
                    return response["thicknessType"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        this.pressureStageStore = new BaasicDropdownStore(
            {
                filterable: false,
                multi: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "pressurestage"
                    );
                    return response["pressureStage"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        this.applicationTypeStore = new BaasicDropdownStore(
            {
                filterable: false,
                multi: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "applicationtype"
                    );
                    return response["applicationType"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        this.dressingCategoryStore = new BaasicDropdownStore(
            {
                filterable: false,
                multi: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "dressingcategory"
                    );
                    return response["dressingCategory"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        this.dressingTypeStore = new BaasicDropdownStore(
            {
                filterable: false,
                multi: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "dressingtype"
                    );
                    return response["dressingType"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        if (id != null) {
            this.isExistingDressingRule = true;
            this.setFormData();
        }
    }

    @action.bound
    async toggleBordered() {
        this.isBordered = !this.isBordered;
    }

    @action.bound
    async toggleDressingChange() {
        this.isDressingChange = !this.isDressingChange;
    }

    @action.bound
    async onSubmit() {
        const { notificationStore } = this.rootStore;

        const service = new DressingRuleService(
            this.rootStore.application.baasic.apiClient
        );
        this.form.$("border").set(this.isBordered);
        this.form.$("qty28DaysIsDressingChange").set(this.isDressingChange);
        if (this.isExistingDressingRule) {
            await service.update({
                id: this.rootStore.routerStore.routerState.params.id,
                ...this.form.values(),
            });
        } else {
            let result = await service.create(this.form.values());
            if(!result.data)
            {
                notificationStore.error("A dressing rule with that code already exists");
            }
            else if(result.data)
            {
                this.rootStore.routerStore.goBack();
                notificationStore.success("Successfully created dressing rule.");
            }
        }
        
    }

    async setFormData() {
        const dressingRuleService = new DressingRuleService(
            this.rootStore.application.baasic.apiClient
        );
        const response = await dressingRuleService.get(
            this.rootStore.routerStore.routerState.params.id,
            {
                embed: "WoundAllowedDressingCategories,WoundAllowedDressingTypes,WoundAllowedFrequencyOfCares,ProcedureCode,WoundAllowedThicknessTypes,WoundAllowedPressureStages,WoundAllowedApplicationTypes,WoundAllowedExudateTypes",
            }
        );
        const dressingRule = response.data;
        this.form.$("procedureCodeId").set(dressingRule.procedureCodeId);
        this.form
            .$("hcpcsShortDescription")
            .set(dressingRule.hcpcsShortDescription);
        this.form
            .$("hcpcsLongDescription")
            .set(dressingRule.hcpcsLongDescription);
        this.form.$("dressingTypes").set(
            dressingRule.woundAllowedDressingTypes.map((item) => ({
                id: item.dressingTypeId,
                name: item.dressingType.name,
            }))
        );
        this.form.$("dressingCategories").set(
            dressingRule.woundAllowedDressingCategories.map((item) => ({
                id: item.dressingCategoryId,
                name: item.dressingCategory.name,
            }))
        );
        this.isBordered = dressingRule.border;
        this.form.$("frequenciesOfCare").set(
            dressingRule.woundAllowedFrequencyOfCares.map((item) => ({
                id: item.frequencyOfCareId,
                name: item.frequencyOfCare.name,
            }))
        );
        this.form.$("medicareQty28Days").set(dressingRule.medicareQty28Days);
        this.form
            .$("qty28DaysIsDressingChange")
            .set(dressingRule._28DaysQtyIsDressingChange);
        this.form
            .$("maximumAdditionalQty28Days")
            .set(dressingRule.maximumAdditionalQty28Days);
        this.form
            .$("additionalQtyPerPatient")
            .set(dressingRule.additionalQtyPerPatient);
        this.form.$("exudateTypes").set(
            dressingRule.woundAllowedExudateTypes.map((item) => ({
                id: item.exudateTypeId,
                name: item.exudateType.name,
            }))
        );
        this.form.$("thicknessTypes").set(
            dressingRule.woundAllowedThicknessTypes.map((item) => ({
                id: item.thicknessTypeId,
                name: item.thicknessType.name,
            }))
        );
        this.form.$("applicationTypes").set(
            dressingRule.woundAllowedApplicationTypes.map((item) => ({
                id: item.applicationTypeId,
                name: item.applicationType.name,
            }))
        );
        this.form.$("pressureStages").set(
            dressingRule.woundAllowedPressureStages.map((item) => ({
                id: item.pressureStageId,
                name: item.pressureStage.name,
            }))
        );
    }
}

export default DressingRuleEditViewStore;
